import { forwardRef, memo, useCallback, useMemo } from "react";
import { default as InputMask, Props } from "react-input-mask";
import { Input, InputProps } from "../../Input";

export type CardDateFieldProps = Omit<InputProps<Props>, "onChange" | "value"> & {
  onChange?: (value: string) => void,
  value?: string
}

export const CardDateField = memo<CardDateFieldProps>(forwardRef<any, CardDateFieldProps>((
  {
    onChange,
    value,
    ...props
  }, ref) => {
  const wrappedOnChange = useCallback((e: any) => onChange?.(e?.target?.value || ""), [ onChange ]);
  const formatChars = useMemo(() => ({
    "1": "[0-1]",
    "2": "[0-2]",
    "8": "[1-9]",
    "9": "[0-9]",
  }), []);
  return <Input
    autoComplete="cc-exp"
    autoCorrect="off"
    spellCheck="false"
    inputMode="numeric"
    placeholder={"MM/YY"}
    {...props}
    mask={(value || "").startsWith("0") ? "18/99" : "12/99"}
    // @ts-ignore
    formatChars={formatChars}
    value={value || ""}
    ref={ref}
    component={InputMask}
    type="text"
    onChange={wrappedOnChange}
  />;
}));

export default CardDateField;
